/**
 * 運賃計算を実行してよいかの判定。両画面（/map・カード配車）で共有する。
 *
 * Why not 各 Presenter に判定を置く: 判定に使う値の出どころが画面ごとに違い
 * （/map は Container、カード配車は Presenter が query を持つ）、同じ規則が
 * 2 箇所に散る。切り出せばテストも 1 箇所で済む。
 */

/** 判定に必要な delivery の最小形。id と operations の数だけ見る */
export type TariffTargetDelivery = {
  id: number;
  operations: unknown[];
};

export type TariffAvailabilityInput = {
  /** 対象 query が取得に失敗している */
  isError: boolean;
  /** 対象 query が取得中（段階取得の途中・背景再取得を含む） */
  isFetching: boolean;
  /** 画面に出ているがサーバへ未反映の変更がある（D&D の override・削除の pending・自動配車の実行中） */
  hasUnsettledChange: boolean;
  /** hasUnsettledChange のときに出す理由。未指定なら既定文 */
  unsettledReason?: string;
  /** 実際に送る対象の件数 */
  targetCount: number;
};

/**
 * API は leg_run_operations が空の shift_truck を除外し、除外後が空なら 422 を返す
 * (bulk_calculator_service.rb:33, :100)。FE 側で先に絞って、送る ID と
 * ダイアログの件数と 0 件判定をすべて一致させる。
 */
export function resolveTariffTargetIds(deliveries: TariffTargetDelivery[]): number[] {
  return deliveries.filter((d) => d.operations.length > 0).map((d) => d.id);
}

/**
 * 無効化する理由。null なら実行できる。
 *
 * Why not 条件を並べて最初に見つかったものを返す: 取得に失敗するとデータが
 * 空になり「0 件」も同時に成立する。順序を決めないと本当の原因（取得失敗）が
 * 「対象の配車がありません」に隠れる。
 */
export function resolveTariffDisabledReason({
  isError,
  isFetching,
  hasUnsettledChange,
  unsettledReason,
  targetCount,
}: TariffAvailabilityInput): string | null {
  if (isError) return '配車データを取得できませんでした';
  if (isFetching) return '配車データを読み込み中です';
  if (hasUnsettledChange) return unsettledReason ?? '未確定の変更があります';
  if (targetCount === 0) return '対象の配車がありません';
  return null;
}
